import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card, Table, TableCell, TableRow } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, SecondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png"
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent'
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../../user_dashboard/data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player'
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling';
import Skeleton from '@material-ui/lab/Skeleton';
import Chip from "@material-ui/core/Chip";
import SlowMotionVideoIcon from '@material-ui/icons/SlowMotionVideo';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import ExerciseCompleted from "./sessionCompleted";
import PainSlider from "./feedbackSliderPain";
import DifficultySlider from "./feedbackSliderDifficulty";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'auto',
    padding: 0,
    // small negative margins on small screens to compensate outer padding
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 12,
      overflowX: 'hidden'
    }
  },
  avatar: {
    backgroundColor: colors.orange[600],
    height: 50,
    width: 50
  },
  sidePanelResponsive: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    padding: 0,
    [theme.breakpoints.down(1200)]: {
      position: 'relative',
      top: 0,
      right: 0,
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      height: 'auto',
      zIndex: 1,
      background: 'transparent',
      boxShadow: '0 2px 8px rgba(2,45,85,0.04)',
      borderRadius: 12,
      padding: 0,
      flexDirection: 'column'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 0
    }
  },
  contentContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    // when screen is lg and above, allow row layout (image + content side-by-side)
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row'
    },
    alignItems: 'stretch',
    gap: 12,
    [theme.breakpoints.down('md')]: {
      gap: 8
    }
  },
  leftCol: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
  // make left column full width when media is hidden
  [theme.breakpoints.down('md')]: {
    leftCol: {
      width: '100%',
      minWidth: 0,
      
    }
  },
  rightCol: {
    width: 220,
    minWidth: 160,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    [theme.breakpoints.up('xl')]: {
      order: 2,
      width: '100%'
    }
  },
  counterBox: {},
  imageBox: {
    width: 200,
    height: 200,
    [theme.breakpoints.up('xl')]: {
      width: '100%',
      height: '40vw',
      maxHeight: 320,
      minHeight: 160
    }
  },
  mediaContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 220,
    minWidth: 160,
    marginRight: 0,
    [theme.breakpoints.down(1200)]: {
      width: '100%',
      minWidth: 0,
      marginRight: 0,
      marginBottom: 12,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    [theme.breakpoints.up('lg')]: {
      order: -1,
      width: '100%',
      minWidth: 0,
      marginRight: 0,
      marginBottom: 12,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      '& > img, & > div': {
        display: 'block'
      }
    }
    ,
    // on very small screens align media to top-left
    [theme.breakpoints.down('md')]: {
      // when image is hidden, stretch the container so content can fill
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      width: '100%'
    }
  },
  mediaWrapper: {
    position: 'relative',
    width: '100%',
    maxWidth: 120,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '100%'
    }
    ,
    // previously hid media image on md and smaller; removed so layout can reflow when image is commented out
  },
  mediaCounterAbsolute: {
    position: 'absolute',
    top: 13,
    left: 10,
    zIndex: 20,
    background: 'transparent',
    borderRadius: 8,
    padding: '6px 10px',
    fontWeight: 600,
    color: '#002D55',
    fontSize: 'clamp(11px, 0.9vw, 14px)'
  },
  mediaImage: {
    width: 200,
    height: 200,
    borderRadius: 12,
    overflow: 'hidden',
    maxWidth: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 0,
    paddingTop: 0,
    marginBottom: 0,
    '& img': {
      display: 'block',
      margin: '0 auto',
      width: '100%',
      height: 'auto',
      maxWidth: '100%',
      maxHeight: 320,
      objectFit: 'contain',
      objectPosition: 'center'
    },
    // Apply larger fixed size on md and lg (covers ~13.8" laptop widths)
    [theme.breakpoints.up('md')]: {
      width: 260,
      height: 260,
      alignSelf: 'center'
    },
    [theme.breakpoints.down('md')]: {
      width: 160,
      height: 160,
      alignSelf: 'center'
    },
    [theme.breakpoints.down('sm')]: {
      width: 140,
      height: 140
    ,
      alignSelf: 'flex-start'
    },
    [theme.breakpoints.down('xs')]: {
      width: 120,
      height: 120
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      height: 240,
      maxWidth: '100%',
      maxHeight: 420,
      minHeight: 120,
      marginBottom: 0,
      '& img': {
        objectFit: 'contain',
        margin: '0 auto'
      }
    }
  },
  mediaCounter: {
    background: '#e6eaf0',
    borderRadius: 8,
    padding: '6px 12px',
    fontWeight: 600,
    color: '#002D55',
    fontSize: 'clamp(11px, 0.9vw, 15px)',
    boxShadow: '0 1px 4px rgba(0,45,85,0.08)',
    marginBottom: 0,
    [theme.breakpoints.up('lg')]: {
      marginBottom: 0,
      marginLeft: 12,
      alignSelf: 'center'
    }
  },
  smallScreenReset: {
    marginLeft: 0,
    maxWidth: '100%'
  },
  visualWrapper: {
    width: '100%',
    display: 'flex',
    padding: 0,
    margin: 0,
    flexDirection: 'column',
    background: '#f6f9fc',
    borderRadius: 16,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column'
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      alignItems: 'stretch'
    }
  },
  visualMedia: {
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      borderTopLeftRadius: 12,
      borderBottomLeftRadius: 12,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      width: 160,
      minWidth: 120
    }
  },
  titleText: {
    color: '#002D55',
    fontWeight: 800,
    marginBottom: 4,
    marginTop: 0,
    textAlign: 'left',
    letterSpacing: 0.04,
    fontSize: 'clamp(1.1rem, 2vw, 1.5rem)',
    [theme.breakpoints.down('xl')]: { fontSize: '1.15rem', marginTop: 0 },
    [theme.breakpoints.down('lg')]: { fontSize: '1.1rem', marginTop: 0 },
    [theme.breakpoints.down('md')]: { fontSize: '1rem', marginTop: 0 },
    [theme.breakpoints.down('sm')]: { fontSize: '0.95rem', marginTop: 0 },
    [theme.breakpoints.down('xs')]: { fontSize: '0.9rem', marginTop: 0 }
  },
  descText: {
    marginBottom: 14,
    textAlign: 'left',
    lineHeight: 1.45,
    color: '#344154',
    fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.9rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.85rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
  }
  ,
  // container that holds description + action row; stacks by default, becomes row on small screens
  descAction: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      // hide the old action layout on very small screens; we'll show a mobile-specific grid instead
      display: 'none'
    }
  },
  descActionText: {
    flex: '1 1 auto',
    marginRight: 0,
    [theme.breakpoints.down('sm')]: {
      marginRight: 12
    }
  },
  actionWrapper: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto'
  }
  ,
  // responsive CTA visibility
  ctaInline: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  ctaStickyWrapper: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      position: 'sticky',
      bottom: 12,
      zIndex: 60,
      width: '100%'
    }
  },
  ctaStickyInner: {
    width: '100%',
    maxWidth: 720,
    padding: '0 12px',
    boxSizing: 'border-box',
    margin: '0 auto'
  }
  ,
  // mobile-only responsive grid: left = title+chips, center = button, right = description
  responsiveGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      // left column should occupy exactly half the available width; right column is the remainder
      gridTemplateColumns: '50% 50%',
      // align items to start so elements align to the top; centerActionMobile will center horizontally within its column
      alignItems: 'start',
      columnGap: 0,
      width: '100%',
      padding: '0 clamp(4px, 0.5vw, 8px)',
    }
  },
  titleAndChips: {
    [theme.breakpoints.down('sm')]: {
      gridColumn: '1 / 2',
      // ensure the title + chips block occupies half the card (prevent collapsing)
      minWidth: '275px'
    }
  },
  centerActionMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'start',
      maxWidth: "100%",
      background: "none",
      // keep the button vertically aligned to the bottom, matching chips' distance to divider
      alignSelf: 'end',
      paddingBottom: 'clamp(4px, 0.4vw, 6px)',
    }
  },
  // mobile-only description that sits below the divider
  descOnlyMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      padding: '0 clamp(4px, 0.5vw, 8px)',
    }
  }
  ,
  mobileCompleteButton: {
    background: '#fb741a',
    color: '#fff',
    fontWeight: 700,
    padding: '15px 10px',
    fontSize: 'clamp(12px, 1vw, 16px)',
    lineHeight: 0.5,
    borderRadius: 18,
    marginBlock: 1,
    boxShadow: "none",
    width: '100%',
    textTransform: 'none',
    transition: 'background-color 200ms ease, transform 120ms ease',
    [theme.breakpoints.down('lg')]: {
      padding: '16px 12px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '14px 30px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px 8px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '10px 8px',
    },
    '&:hover': {
      background: '#002D55'
    },
    '&:active': {
      background: '#002D55',
      transform: 'translateY(1px)'
    }
  }
}));
const simpleFormatter = (text, len) => {
  console.log("here3")
  var i = 0;
  for(i = 0; i < text.length; i = i+len){
    if (i != 0) {
      const subString = text.slice(0, i).split("").reverse().join(""); // abc d -> d cba
      const splitIndex = subString.length - subString.indexOf(' ');
      text = text.slice(0, splitIndex) + "\n" + text.slice(splitIndex);
    }
  }
  return text;
}
  

const NextExercises = (props) => {
  const classes = useStyles();
  // Render everything from props.exercise
  const selectedExercise = props.exercise || {};
  const isAscendExercise = String(selectedExercise.source || '').toLowerCase() === 'ascend';
  const instructionText = Array.isArray(selectedExercise.instructions)
    ? selectedExercise.instructions.map((instruction, index) => `${index + 1}. ${instruction}`).join('\n')
    : '';
  const legacyInstructions = String(selectedExercise.description || '')
    .split(/\bInstructions:\s*/i)[1]
    ?.split(/\b(?:Tips|Common mistakes|Variations):\s*/i)[0]
    ?.trim() || '';
  const displayDescription = isAscendExercise && instructionText
    ? instructionText
    : isAscendExercise
      ? (legacyInstructions || 'No instructions available.')
      : (selectedExercise.description || 'No description available.');
  const doseType = selectedExercise.doseType || (
    selectedExercise.time != null && selectedExercise.time > 0 ? 'time' : 'repetitions'
  );
  const isStrengthDose = ['repetition_maximum', 'weight_kg', 'weight_total_kg', 'weight_lbs', 'weight_total_lbs'].includes(doseType);
  const renderDescription = () => {
    if (!isAscendExercise) return displayDescription;
    const instructions = displayDescription.split('\n').filter(Boolean);
    return instructions.map((instruction, index) => {
      const match = instruction.match(/^(\d+\.)(\s*)(.*)$/);
      return (
        <Box key={`${instruction}-${index}`} component="span" style={{ display: 'block', marginBottom: index < instructions.length - 1 ? 4 : 0 }}>
          {match ? <><strong>{match[1]}</strong>{match[2]}{match[3]}</> : instruction}
        </Box>
      );
    });
  };
  // Completion tracker from parent props
  const currentExerciseIndex = typeof props.currentExerciseIndex === 'number' ? props.currentExerciseIndex : 0;
  const totalExercises = typeof props.totalExercises === 'number' ? props.totalExercises : (props.nextExercises ? props.nextExercises.length : 1);

  return (
    <div className={classes.root} style={{ position: 'relative' }}>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        style={{
          width: '100%',
          padding: '0px 0',
          flexWrap: 'wrap',
          background: 'none',
        }}
      >
        {/* wrap the main right-column content so responsive styles can pin it on md/sm */}
          {/* Authoritative details area for selected exercise */}
          <Box display="flex" flexDirection="column" alignItems="center" style={{ width: '100%', background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)', borderRadius: 16, padding: 'clamp(10px, 1.2vw, 16px)', boxSizing: 'border-box' }}>
            {/* Responsive content: on sm/md/lg layout is two-column with image/counter on the left; on XL keep stacked layout */}
            <Box className={classes.contentContainer} style={{ width: '100%', alignItems: 'flex-start', paddingTop: 0, marginTop: 0 }}>
              <Box className={classes.leftCol} style={{ flex: 1 }}>
                <Box className={classes.responsiveGrid}>
                  <Box className={classes.titleAndChips}>
                    <Typography variant="h5" className={classes.titleText}>
                      {selectedExercise.title}
                    </Typography>
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      style={{
                        width: '100%',
                        marginTop: 0,
                        marginBottom: 2,
                        gap: 0,
                        flexWrap: 'wrap',
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        style={{
                          background: '#f7f9fc',
                          borderRadius: 14,
                          padding: 'clamp(4px, 0.5vw, 6px) clamp(8px, 0.9vw, 12px)',
                          boxShadow: 'none',
                          marginRight: 'clamp(4px, 0.4vw, 6px)',
                          marginBottom: 'clamp(4px, 0.4vw, 6px)',
                        }}
                      >
                        <SlowMotionVideoIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />
                        <Typography variant="body2" style={{ color: '#324158', fontWeight: 600, fontSize: 'clamp(0.75rem, 0.9vw, 0.875rem)' }}>
                          {`${selectedExercise.sets || 0} sets`}
                        </Typography>
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        style={{
                          background: '#f7f9fc',
                          borderRadius: 14,
                          padding: 'clamp(4px, 0.5vw, 6px) clamp(8px, 0.9vw, 12px)',
                          boxShadow: 'none',
                          marginBottom: 'clamp(4px, 0.4vw, 6px)',
                        }}
                      >
                        {isStrengthDose
                          ? <FitnessCenterIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />
                          : <PlayCircleOutlineIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />}
                        <Typography variant="body2" style={{ color: '#324158', fontWeight: 600, fontSize: 'clamp(0.75rem, 0.9vw, 0.875rem)' }}>
                          {(() => {
                            // Mirror the rest of the app: explicit doseType wins,
                            // otherwise non-zero time means time-based, else repetitions-based.
                            if (doseType === 'repetition_maximum') {
                              return `${selectedExercise.repetitionMaximum || 0} RM`;
                            }
                            if (doseType === 'weight_kg') return `${selectedExercise.weightKg || 0} kg`;
                            if (doseType === 'weight_total_kg') return `${selectedExercise.weightTotalKg || 0} total kg`;
                            if (doseType === 'weight_lbs') return `${selectedExercise.weightLbs || 0} lbs`;
                            if (doseType === 'weight_total_lbs') return `${selectedExercise.weightTotalLbs || 0} total lbs`;
                            return doseType === 'time'
                              ? `${selectedExercise.time || 0} sec.`
                              : `${selectedExercise.repetitions || 0} reps`;
                          })()}
                        </Typography>
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        style={{
                          background: '#f7f9fc',
                          borderRadius: 14,
                          padding: 'clamp(4px, 0.5vw, 6px) clamp(8px, 0.9vw, 12px)',
                          boxShadow: 'none',
                          marginLeft: 'clamp(4px, 0.4vw, 6px)',
                          marginBottom: 'clamp(4px, 0.4vw, 6px)',
                        }}
                      >
                        <PauseCircleOutlineIcon style={{ color: '#fb741a', marginRight: 'clamp(4px, 0.4vw, 6px)', fontSize: 'clamp(15px, 1.3vw, 20px)' }} />
                        <Typography variant="body2" style={{ color: '#324158', fontWeight: 600, fontSize: 'clamp(0.75rem, 0.9vw, 0.875rem)' }}>
                          {`Pause: ${parseInt(selectedExercise.pause, 10) || 0} sec`}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* mobile-centered action (only visible on sm and xs) */}
                  <Box className={classes.centerActionMobile}>
                    <Button className={classes.mobileCompleteButton} variant="contained" onClick={() => {
                              if (typeof props.goToFeedback === 'function') {
                                props.goToFeedback();
                              }
                            }}
                            aria-label="feedback"
                    >
                      COMPLETE
                    </Button>
                  </Box>

                  {/* description removed from grid to avoid duplication; mobile description shown below divider */}
                </Box>

                {/* divider and original action (kept for md+ screens) */}
                <Divider style={{ width: '100%', margin: '0px 0 10px 0', background: '#e0e5ee' }} />
                {/* mobile-only description placed below divider to preserve mobile layout */}
                <Box className={classes.descOnlyMobile}>
                  <Typography variant="body1" color="textSecondary" className={clsx(classes.descText)} style={{ whiteSpace: 'pre-wrap' }}>
                    {renderDescription()}
                  </Typography>
                </Box>
                <Box className={classes.descAction}>
                  <Typography variant="body1" color="textSecondary" className={clsx(classes.descText, classes.descActionText)} style={{ whiteSpace: 'pre-wrap' }}>
                    {renderDescription()}
                  </Typography>
                  <Box className={classes.actionWrapper}>
                    <Button className={classes.mobileCompleteButton} variant="contained"
                            onClick={() => {
                              if (typeof props.goToFeedback === 'function') {
                                props.goToFeedback();
                              }
                            }}
                            aria-label="feedback"
                    >
                      COMPLETE
                    </Button>
                  </Box>
                </Box>
              </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};


export default NextExercises;
